import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, categoryBySlug } from "../lib/api";
import ArticleCard from "../components/ArticleCard";

export default function Category() {
  const { slug } = useParams();
  const cat = categoryBySlug(slug);
  const [articles, setArticles] = useState([]);
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    const params = { category: slug, limit: 60 };
    if (filter) params.sub_category = filter;
    api.get("/articles", { params }).then((r) => setArticles(r.data));
  }, [slug, filter]);

  if (!cat) return <div className="p-10">Catégorie inconnue.</div>;

  const isWayOfLife = slug === "way-of-life";

  return (
    <div data-testid={`category-${slug}-page`}>
      <section
        className="border-b-2 border-black"
        style={{ background: cat.color, color: cat.textColor }}
      >
        <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16 lg:py-24">
          <Link
            to="/"
            className="text-xs uppercase font-bold tracking-widest opacity-70 hover:opacity-100"
          >
            ← Bon Sang !
          </Link>
          <h1 className="font-display-black text-6xl sm:text-8xl lg:text-[9rem] mt-4 leading-none">
            {cat.label}
          </h1>
          <p className="mt-4 max-w-2xl text-base sm:text-lg">
            {descriptionFor(slug)}
          </p>

          {isWayOfLife && (
            <div className="mt-8 flex flex-wrap gap-2" data-testid="sub-category-filters">
              <button
                onClick={() => setFilter(null)}
                data-testid="filter-all"
                style={
                  filter === null
                    ? { background: "#050505", color: "#FFFDF7" }
                    : { background: "#FFFDF7", color: "#050505" }
                }
                className="px-4 py-2 rounded-full border-2 border-black text-xs font-bold uppercase tracking-widest"
              >
                Tout
              </button>
              <button
                onClick={() => setFilter("les-premieres-fois")}
                data-testid="filter-les-premieres-fois"
                style={
                  filter === "les-premieres-fois"
                    ? { background: "#050505", color: "#FFFDF7" }
                    : { background: "#FFFDF7", color: "#050505" }
                }
                className="px-4 py-2 rounded-full border-2 border-black text-xs font-bold uppercase tracking-widest"
              >
                Les premières fois
              </button>
            </div>
          )}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-16">
        {articles.length === 0 ? (
          <p className="text-sm text-black/60">Aucun article pour l&apos;instant.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {articles.map((a) => (
              <ArticleCard key={a.id} article={a} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

function descriptionFor(slug) {
  switch (slug) {
    case "way-of-life":
      return "Tranches de vie, premières fois, amours mal classées. Ici, on raconte la vie comme elle gicle.";
    case "sexploration":
      return "Plaisir, anatomie, mythes : on cartographie ce que personne n'ose dessiner.";
    case "chut-on-teste":
      return "On essaie pour toi. Sextoys, lubrifiants, applis. Verdict sans filtre.";
    case "intimite-masculine":
      return "Côté vestiaire des mecs : virilité, fragilité, désirs. Sans clichés.";
    case "podcast":
      return "Toutes les conversations Bon Sang ! En ligne tous les vendredis.";
    default:
      return "";
  }
}
